import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: [ './progress-bar.component.scss' ]
})
export class ProgressBarComponent implements OnChanges {

  @Input() progress: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.progress.currentValue) {
      this.progress = changes.progress.currentValue;
    }
  }
}
